import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spacing(5)};
  align-items: start;
  width: 100%;

  > * {
    min-width: 0;
  }

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`
